<template>
  <vs-popup class="customer-site-create-popup"
            id="popup"
            title="UPDATE CUSTOMER PROJECT BRIEF"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="createForm.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <span style="display: none">{{createForm}}</span>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="createForm.description" height="200px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      createForm: {
        address: {}
      },
      id: '',
      countryCodes: [],
      customerUsers: []
    }
  }

export default {
  name: 'TrackingImagePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.$vs.loading();
        await this.fetchProjectBriefDetails()
        this.$vs.loading.close();
        this.open = true;
      } catch (error) {

      }
    },

    async onClickCreateSite () {
      const vue = this;
      this.$vs.loading()
       try {
         await CustomerRepository.updateCustomerProjectBrief(this.id, this.createForm)
         this.showSuccessMessage('Project brief updated successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async fetchProjectBriefDetails() {
      this.$vs.loading()
      const {data} = await CustomerRepository.getSingleProjectBrief(this.id)
      this.createForm =  data.data
      this.$vs.loading.close()
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-site-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }

</style>
